function updateMenuSelection() {
  // 既存の選択状態をクリア
  $('li.selected').removeClass('selected');

  // 現在のURLに一致するリンクを探して親のliにselectedクラスを追加
  $('[href]').each(function () {
    if (this.href.split('?')[0] == window.location.href.split('?')[0]) {
      $(this).parent('li').addClass('selected');
    }
  });
}

// 初期ロード時とTurbo遷移時の両方に対応
document.addEventListener('turbo:load', updateMenuSelection);
